/**
 * notaDoEvento — traduz a nota de máquina do histórico do chamado (TASK-10274).
 *
 * Os INSERTs gravam códigos (`task_request_created`, `assignee_changed:31997`) e a
 * auditoria proíbe reescrever o histórico já gravado — por isso a tradução mora na
 * apresentação. Nota que já é texto para gente ler passa como está.
 */
const FIXAS: Record<string, string> = {
  task_request_created: 'Chamado aberto',
  task_request_in_triage: 'Chamado em triagem',
  task_request_submitted_for_approval: 'Chamado enviado para aprovação',
  gmud_draft_created: 'Rascunho de GMUD criado',
}

export function notaDoEvento(note: string | null | undefined): string | null {
  if (!note) return null
  const fixa = FIXAS[note]
  if (fixa) return fixa
  if (note.startsWith('assignee_changed:')) {
    const alvo = note.slice('assignee_changed:'.length)
    return alvo === '' || alvo === 'None' || alvo === 'null' ? 'Atendente removido' : 'Atendente atribuído'
  }
  const anexo = /^attachment_id:\d+:(.+)$/.exec(note)
  if (anexo) return `Anexo: ${anexo[1]}`
  // Qualquer outro código de máquina (snake_case, sem espaço) não vai cru para a tela.
  if (/^[a-z0-9]+(_[a-z0-9]+)+(:[^\s]*)?$/.test(note)) return null
  return note
}
